import React, { Component } from "react"
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom"
import { connect } from "react-redux"
import ProtectRoute from "./components/auth/RoleProtect"
import Sidebar from "./components/layout/Sidebar"
import Footer from "./components/layout/Footer"
import route from './config/routes'
import { ROLE, ROUTE_ACCESS, ACCESS } from './config/index'
import Header from "./components/layout/Navbar"
import Login from './components/Login'
import Logout from './components/Logout'
import Dashboard from "./components/dashboard/index"
import UsersList from './components/users/List'
import UserDetail from './components/users/Detail'
import AdminList from './components/admin-users/List'
import AuctionsList from './components/auctions/List'
import AuctionDetail from './components/auctions/Detail'
import TransactionsList from './components/transactions/List'
import Lookups from './components/lookups/List'
import Relations from "./components/lookups/Relation"
import FaqsTypes from "./components/faqsTypes/List"
import News from './components/news/List'
import Faqs from './components/faqs/List'
import Feedbacks from './components/feedback/List'
import PromoCodes from './components/promo/List'
import RedeemCodes from './components/redeem/List'
import RedeemDetail from './components/redeem/Detail'
import TransactionDetail from './components/transactions/Detail'
import ReferralCodes from './components/referral-codes/List'
import ListCountries from './components/countries/List'
import UsersRewardsList from './components/rewards/UserRewards'
import UsersCollectionList from './components/collections/UserCollections'
import RewardsList from './components/rewards/List'
import BadgesList from './components/badges/List'
import Collections from './components/collections/List'
import DetailCollection from './components/collections/Detail'
import UsersNotifications from './components/users/Notifications'
import WalletHistory from './components/wallet/List'
import ItemCopiesList from './components/nft-copy/List'
import Nfts from './components/nfts/List'
import Reserve from './components/nfts/Reserve'
import Release from './components/nfts/Release'
import ImportItems from './components/nfts/Import'
import ItemsStatus from './components/nfts/Status'
import CartItems from './components/cart/List'
import TeamsList from './components/isl-teams/List'
import IslRewards from './components/isl-reward/FreeNft'
import BrandCards from './components/brand-cards/List'
import Reporting from './components/reporting/List'
import CreateJSON from './components/create-json/index'
import NoMatch from './components/NoMatch'
import { addLogin } from './actions/loggedin_action'
import Loader from './components/layout/Loader'
import ChangePassword from "./components/ChangePassword"
import Settings from "./components/Settings"
import Summary from "./components/Summary"
import Campaigns from "./components/Campaigns"
import AppVision from "./components/app-vision/Index"
import UpdateUserAmount from "./components/wallet/UpdateAmount"
import CampaignTransfer from './components/campaign-transfer/List'
import UpdateAmountDetail from "./components/wallet/UpdateAmountDetail"
import CmsPages from "./components/cms-pages/List";
import CmsPageDetail from "./components/cms-pages/Detail"
import CmsSectionDetail from "./components/cms-pages/cms-section/Detail";
import PageList from "./components/pages/List";

class App extends Component {

    render() {
        fakeAuth.isAuthenticated = this.props.isLogin
        return (
            <Router>
                {
                    this.props.isLogin ? (
                        <>
                            <Sidebar />
                            <div class="page-container">
                                <div class="page-content">
                                    <Loader />
                                    <Header />
                                    <Switch>
                                        <IfUserAuthRoute path={route.INDEX} exact component={Login} />
                                        <PrivateRoute path={route.DASHBOARD} component={Dashboard} />
                                        <PrivateRoute path={route.CHANGE_PASSWORD} component={ChangePassword} />
                                        <PrivateRoute path={route.SETTING} component={Settings} />
                                        <PrivateRoute path={route.SUMMARY} component={Summary} />
                                        <PrivateRoute path={route.LOGOUT} component={Logout} />
                                        <PrivateRoute path={`${route.CAMPAIGN}:id`} component={Campaigns} />

                                        <PrivateRoute path={`${route.DETAIL_AUCTION}:id`} component={AuctionDetail} rightsNeeded={[ROUTE_ACCESS.AUCTION.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.LIST_AUCTION} component={AuctionsList} rightsNeeded={[ROUTE_ACCESS.AUCTION.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.LIST_USER} component={UsersList} rightsNeeded={[ROUTE_ACCESS.USER.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={`${route.DETAIL_USER}:id`} component={UserDetail} rightsNeeded={[ROUTE_ACCESS.USER.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={`${route.UPDATE_AMOUNT_DETAIL}:id`} component={UpdateAmountDetail} ightsNeeded={[ROLE.ADMIN]} />
                                        <PrivateRoute path={`${route.UPDATE_USER_AMOUNT}`} component={UpdateUserAmount} rightsNeeded={[ROLE.ADMIN]} />
                                        <PrivateRoute path={route.LIST_NEWS} component={News} rightsNeeded={[ROUTE_ACCESS.NEWS.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.LIST_ADMIN_USER} component={AdminList} rightsNeeded={[ROUTE_ACCESS.ADMIN_USERS, ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.LIST_COUPON} component={PromoCodes} rightsNeeded={[ROUTE_ACCESS.PROMOCODE.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.LIST_REDEEM} component={RedeemCodes} rightsNeeded={[ROUTE_ACCESS.REDEEMCODE.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={`${route.DETAIL_REDEEM}:id`} component={RedeemDetail} rightsNeeded={[ROUTE_ACCESS.REDEEMCODE.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.LIST_COUNTRIES} component={ListCountries} rightsNeeded={[ROUTE_ACCESS.COUNTRIES.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.LIST_FAQS} component={Faqs} rightsNeeded={[ROUTE_ACCESS.FAQ.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.LIST_FAQ_TYPES} component={FaqsTypes} rightsNeeded={[ROUTE_ACCESS.FAQ.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.LIST_FEEDBACK} component={Feedbacks} rightsNeeded={[ROUTE_ACCESS.FEEDBACK.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.LIST_LOOKUP} component={Lookups} rightsNeeded={[ROUTE_ACCESS.LOOKUP.toLowerCase(), ACCESS.READ.toLowerCase()]} />

                                        <PrivateRoute path={route.USERS_COLLECTION} component={UsersCollectionList} rightsNeeded={[ROUTE_ACCESS.COLLECTION.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.LIST_COLLECTION} component={Collections} rightsNeeded={[ROUTE_ACCESS.COLLECTION.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={`${route.DETAIL_COLLECTION}:id`} component={DetailCollection} rightsNeeded={[ROUTE_ACCESS.COLLECTION.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.USERS_REWARDS} component={UsersRewardsList} rightsNeeded={[ROUTE_ACCESS.REWARDS.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.LIST_REWARDS} component={RewardsList} rightsNeeded={[ROUTE_ACCESS.REWARDS.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.LIST_BADGES} component={BadgesList} rightsNeeded={[ROUTE_ACCESS.BADGES.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.RELEASE_NFT} component={Release} rightsNeeded={[ROUTE_ACCESS.RELEASENFT.toLowerCase(), ACCESS.WRITE.toLowerCase()]} />
                                        <PrivateRoute path={route.IMPORT_NFT} component={ImportItems} rightsNeeded={[ROUTE_ACCESS.IMPORTNFT.toLowerCase(), ACCESS.WRITE.toLowerCase()]} />
                                        <PrivateRoute path={route.RESERVE_NFT} component={Reserve} rightsNeeded={[ROUTE_ACCESS.RESERVENFT.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.LIST_NFT} component={Nfts} rightsNeeded={[ROUTE_ACCESS.NFT.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.NFT_STATUS} component={ItemsStatus} rightsNeeded={[ROUTE_ACCESS.NFT.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.LIST_NFT_COPIES} component={ItemCopiesList} rightsNeeded={[ROUTE_ACCESS.NFTCOPY.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={route.LIST_TRANSACTIONS} component={TransactionsList} rightsNeeded={[ROUTE_ACCESS.TRANSACTION.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={`${route.TRANSACTIONS_BY_ID}/:id`} component={TransactionDetail} rightsNeeded={[ROUTE_ACCESS.TRANSACTION.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={`${route.LIST_CART_ITEMS}`} component={CartItems} rightsNeeded={[ROUTE_ACCESS.CART.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={`${route.LIST_WALLET_HISTORY}`} component={WalletHistory} rightsNeeded={[ROUTE_ACCESS.WALLET.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={`${route.RelationList}`} component={Relations} rightsNeeded={[ROUTE_ACCESS.LOOKUP.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={`${route.USERS_NOTIFICATIONS}`} component={UsersNotifications} rightsNeeded={[ROUTE_ACCESS.USERSNOTIFICATIONS.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={`${route.REFERRAL_CODES}`} component={ReferralCodes} rightsNeeded={[ROUTE_ACCESS.REFERRALCODES.toLowerCase(), ACCESS.READ.toLowerCase()]} />
                                        <PrivateRoute path={`${route.CREATE_JSON}`} component={CreateJSON} rightsNeeded={[ROLE.ADMIN]} />
                                        <PrivateRoute path={route.LIST_ISL_REWARDS} component={IslRewards} rightsNeeded={[ROLE.ADMIN]} />
                                        <PrivateRoute path={route.LIST_TRADING_CARDS} component={BrandCards} rightsNeeded={[ROLE.ADMIN]} />
                                        <PrivateRoute path={route.LIST_TEAMS} component={TeamsList} rightsNeeded={[ROLE.ADMIN]} />
                                        <PrivateRoute path={route.LIST_REPORTING} component={Reporting} rightsNeeded={[ROLE.ADMIN]} />
                                        <PrivateRoute path={`${route.APP_VISION}`} component={AppVision} rightsNeeded={[ROLE.ADMIN]} />
                                        <PrivateRoute path={`${route.CAMPAIGN_TRANSFER}`} component={CampaignTransfer} rightsNeeded={[ROLE.ADMIN]} />
                                        <PrivateRoute path={`${route.CMS_PAGES}`} component={CmsPages} rightsNeeded={[ROLE.ADMIN]} />
                                        <PrivateRoute path={`${route.CMS_PAGE_DETAIL}:id`} component={CmsPageDetail} rightsNeeded={[ROLE.ADMIN]} />
                                        <PrivateRoute path={`${route.CMS_SECTION_DETAIL}:id`} component={CmsSectionDetail} rightsNeeded={[ROLE.ADMIN]} />
                                        <PrivateRoute path={route.LIST_PAGES} component={PageList} rightsNeeded={[ROLE.ADMIN]} />
                                        <Route component={NoMatch} />
                                    </Switch>
                                </div>
                                <Footer />
                            </div>
                        </>
                    ) : (
                        <div>
                            <Redirect to={route.INDEX} />
                            <IfUserAuthRoute path={route.INDEX} exact component={Login} />
                        </div>
                    )}
            </Router>
        )
    }
}

const fakeAuth = {
    isAuthenticated: false
}

function IfUserAuthRoute({ component: Component, ...rest }) {
    return (
        <Route
            {...rest}
            render={props =>
                fakeAuth.isAuthenticated ? (
                    <Redirect
                        to={{
                            pathname: route.DASHBOARD,
                            state: { from: props.location }
                        }}
                    />
                ) : (
                    <Component {...props} />
                )
            }
        />
    )
}

function PrivateRoute({ component: Component, rightsNeeded, ...rest }) {
    return (
        <Route
            {...rest}
            render={props => {
                return (
                    fakeAuth.isAuthenticated ? (
                        rightsNeeded && rightsNeeded.length > 0 ?
                            (
                                <ProtectRoute component={Component} rightsNeeded={rightsNeeded} {...props} />
                            ) :
                            <Component {...props} />
                    ) : (
                        <Redirect
                            to={{
                                pathname: route.INDEX,
                                state: { from: props.location }
                            }}
                        />
                    )
                )
            }}
        />
    )
}

const mapStateToProps = state => {
    return {
        isLogin: state.isLogin,
        profile: state.profile
    }
}

const mapDispatchToProps = {
    addLogin
}

export default connect(mapStateToProps, mapDispatchToProps)(App)

